import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { getPost } from "../api";
import Header from "./Header";
import Footer from "./Footer";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getPost(slug)
      .then(setPost)
      .catch(() => setError("Post not found"))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <p className="text-gray-500">{error}</p>
        <Link to="/blog" className="text-primary-500 hover:underline">
          &larr; Back to blog
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <div className="bg-primary-animated relative">
        <Header />
        <div className="pt-32 pb-16 px-6 text-center">
          <p className="text-primary-100 text-sm uppercase tracking-wide">
            {new Date(post.date).toLocaleDateString("en-AU", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
          <h1 className="mt-3 text-3xl md:text-5xl font-black text-white max-w-3xl mx-auto">
            {post.title}
          </h1>
          {post.author && <p className="mt-4 text-gray-300">by {post.author}</p>}
        </div>
      </div>

      {/* Content */}
      <main className="flex-1 max-w-screen-md mx-auto w-full py-12 px-6">
        <Link to="/blog" className="text-primary-500 hover:underline text-sm mb-8 inline-block">
          &larr; Back to blog
        </Link>
        <article className="prose prose-lg max-w-none">
          <ReactMarkdown>{post.content || ""}</ReactMarkdown>
        </article>
      </main>

      <Footer />
    </div>
  );
}
